module.exports = __webpack_public_path__ + "img/robot-arm.886e4794.svg";